module.exports = __webpack_public_path__ + "static/img/teacher.beee6719.png";